import { displayDefaultDateTime } from 'app/shared/util/date-utils';

export const columns = [
  {
    title: 'Tên',
    key: 'name',
    sorter: true,
    dataIndex: 'name',
  },
];
